import LazyLoad from "vanilla-lazyload";
import { initializeMap } from "Functions/map";

import "Layouts/default";

const branches = window.branchesData;
let mapInitialized = false;

window.mapLazyLoad = new LazyLoad({
    threshold: 125,
    elements_selector: ".js-map-branches",
    callback_enter: (el) => {
        if (!mapInitialized) {
            // bez center/zoom – mapa sa vycentruje podľa markerov (fitBounds)
            initializeMap(".js-map-branches", branches);
            mapInitialized = true;
        }
    },
});

$(function () {
    $(".js-form-contact").validate({
        rules: {
            name: {
                minlength: 3,
            },
            message: {
                minlength: 5,
            },
        },
        errorPlacement: function (error, element) {
            if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            Form.ajaxPost(
                form,
                function (data) {
                    var msg = data.msg.format;
                    if (!msg) {
                        msg = data.msg;
                    }
                    $(".js-contact-error").hide();
                    if (!data.status) {
                        $(".js-contact-error").text(msg).slideDown();
                    } else {
                        $(form).slideUp(250, function () {
                            $(".js-contact-success").text(msg).slideDown(250);
                        });
                    }
                    rEvent.dispatch("Recaptcha.execute");
                },
                "json"
            );
        },
    });
});
